import { useEffect, useRef } from 'react';

export default function useAutoRefresh(callback, interval = 30000) {
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => savedCallback.current();
    tick();
    const id = setInterval(tick, interval);
    return () => clearInterval(id);
  }, [interval]);
}
